import React from 'react';
import { Chip } from '@mui/material';

interface ChatSuggestionChipProps {
  label: string;
  icon?: React.ReactElement;
  onClick: () => void;
  variant?: 'outlined' | 'filled';
  color?: 'default' | 'primary' | 'secondary' | 'error' | 'info' | 'success' | 'warning';
  sx?: any;
}

export const ChatSuggestionChip: React.FC<ChatSuggestionChipProps> = React.memo(
  ({ label, icon, onClick, variant = 'outlined', color = 'default', sx }) => {
    return (
      <Chip
        label={label}
        icon={icon}
        onClick={onClick}
        variant={variant}
        color={color}
        sx={{
          cursor: 'pointer',
          borderRadius: '12px',
          padding: '8px 12px',
          fontSize: '12.5px',
          fontWeight: 600,
          backgroundColor: variant === 'filled' ? undefined : '#FFFFFF',
          borderColor: '#EAEAEA',
          color: '#1A1A1A',
          height: 'auto',
          transition: 'all 0.2s ease',
          '& .MuiChip-label': {
            paddingLeft: icon ? '4px' : '8px',
            paddingRight: '8px',
          },
          '&:hover': {
            borderColor: '#B0B0B0',
            backgroundColor: '#FAFAFA',
            transform: 'translateY(-1px)',
            boxShadow: '0px 2px 6px rgba(0, 0, 0, 0.04)',
          },
          '&:focus-visible': {
            outline: '2px solid #111111',
            outlineOffset: '2px',
            borderColor: '#111111',
          },
          ...sx,
        }}
      />
    );
  },
);

ChatSuggestionChip.displayName = 'ChatSuggestionChip';
